import { SvgIcon, SvgIconProps } from '@material-ui/core';

const Arrow = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 25">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Group-19" transform="translate(0.000000, 0.500000)">
          <circle id="Oval" fill="#FFFFFF" cx="12" cy="12" r="12"></circle>
          <g id="Group-21" fill="currentColor">
            <path
              d="M12,0 C5.376,0 0,5.376 0,12 C0,18.624 5.376,24 12,24 C18.624,24 24,18.624 24,12 C24,5.376 18.624,0 12,0 Z M12,21.6 C6.708,21.6 2.4,17.292 2.4,12 C2.4,6.708 6.708,2.4 12,2.4 C17.292,2.4 21.6,6.708 21.6,12 C21.6,17.292 17.292,21.6 12,21.6 Z"
              id="Shape"
              fillRule="nonzero"
            ></path>
            <path
              d="M12.2,4.8 C12.7522847,4.8 13.2,5.24771525 13.2,5.8 L13.1998312,15.101 L16.384062,11.9179479 C16.7745863,11.5274236 17.4077513,11.5274236 17.7982756,11.9179479 L18.0811183,12.2007906 C18.4716426,12.5913149 18.4716426,13.2244799 18.0811183,13.6150042 L13.1297058,18.5690268 C13.0162922,18.8545104 12.7751906,19.07539 12.4768988,19.161168 C12.3818858,19.2127428 12.2803422,19.2477815 12.1764315,19.2663111 L12.0590314,19.2801759 L12.0590314,19.2801759 L11.9409686,19.2801759 C11.8230163,19.2732435 11.7060579,19.2455139 11.5960574,19.1969872 L11.5220984,19.1608791 C11.2235614,19.0746905 10.9824371,18.8531407 10.8694888,18.5669928 L5.91888168,13.6150042 C5.52835739,13.2244799 5.52835739,12.5913149 5.91888168,12.2007906 L6.20172439,11.9179479 C6.59224869,11.5274236 7.22541366,11.5274236 7.61593796,11.9179479 L10.7998312,15.101 L10.8,5.8 C10.8,5.24771525 11.2477153,4.8 11.8,4.8 L12.2,4.8 Z"
              id="Combined-Shape"
              transform="translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) "
            ></path>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default Arrow;
